import React from 'react';
import { useStore } from '../../../../../store';
import { FormSelect } from '../../../../../../../../components/form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

export const BankAccountSelect = ({ name, required }) => {
    const { t } = useTranslation();

    const {
        bankAccounts: { bankAccounts }
    } = useStore();

    const options = bankAccounts?.map(({ id, name }) => {
        return { value: id, text: name };
    });

    return (
        <FormSelect
            name={name}
            required={required}
            label={t('sauron.financeModule.payoutProfiles.drawer.fields.bankAccount.label')}
            placeholder={t('sauron.financeModule.payoutProfiles.drawer.fields.bankAccount.placeholder')}
            options={options}
        />
    );
};

BankAccountSelect.propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool
};
